import Vue from 'vue';
import Router from 'vue-router';
import i18n from '@/i18n';

import Full from '@/Full';

import LegalDisclaimer from '@/components/LegalDisclaimer';
import SilentRenew from '@/components/SilentRenew';

import Cockpit from '@/components/Dashboard-APP_TARGET';
// import MapView from '@/components/MapView';

import CheckExplorer from '@/components/Survey/CheckExplorer';
import MediaExplorer from '@/components/Survey/MediaExplorer';
import ReportFileExplorer from '@/components/ReportFile/ReportFileExplorer';
import ReportFileImport from '@/components/ReportFile/ReportFileImport';
import RawData from '@/components/Survey/RawData-APP_TARGET';
import Frequencies from '@/components/Survey/Frequencies';
import AggregatedReports from '@/components/Survey/AggregatedReports-APP_TARGET';
import SurveyRevision from '@/components/Action/SurveyRevision';
import SurveyImprovement from '@/components/Action/SurveyImprovement';
import MarketReports from '@/components/MarketReports/MarketReports';

import CX from '@/components/CX-APP_TARGET';
import CXMarginFileImport from '@/components/CX/DashboardCards/MarginFileImport';

import ExternalLogin from '@/components/External/Login';
import ExternalSignedOut from '@/components/External/SignedOut';
import ExternalSurveyRevisions from '@/components/External/SurveyRevisions';
import ExternalSurveyImprovements from '@/components/External/SurveyImprovements';
import ExternalNotificationSettings from '@/components/External/NotificationSettings';

import Administration from '@/components/Administration/Administration';
import AdministrationNoMSMUser from '@/components/Administration/AdministrationNoMSMUser';
import ClientSettings from '@/components/Administration/ClientSettings';
import SurveySettings from '@/components/Administration/SurveySettings';
import GeneralSettings from '@/components/Administration/GeneralSettings';
import CXSettings from '@/components/Administration/CXSettings';
import CXClientSettings from '@/components/Administration/CXClientSettings';
import CXFirstAidSettings from '@/components/Administration/CXFirstAidSettings';
import CXCompetitorSettings from '@/components/Administration/CXCompetitorSettings';
import AdministrationMarketReports from '@/components/Administration/MarketReports';

import UserSettings from '@/components/User/UserSettings';
import UserProfile from '@/components/User/UserProfile';
import NotificationSettings from '@/components/User/NotificationSettings';
import LocationNotifications from '@/components/User/LocationNotifications';
import Download from '@/components/Download';

import Imprint from '@/components/Imprint';
import DataProtection from '@/components/DataProtection';
import Page401 from '@/components/Page401';
import Page404 from '@/components/Page404';
import Page500 from '@/components/Page500';
import PageSignInFailed from '@/components/PageSignInFailed';
import Callback from '@/components/Callback';
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import Comparison from '@/components/Comparison-APP_TARGET';

import AuthenticationService from '@/services/AuthenticationService';

import Tap from '@/components/VW-TAP/Dashboard-tap';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',

  routes: [
    {
      path: '/',
      name: 'Home',
      meta: { MessageKey: 'Webportal.Home', requiresAuth: true },
      redirect: '/cx', // Fallback will be applied while checking permission
      component: Full,
      children: [
        {
          path: 'legaldisclaimer',
          name: 'LegalDisclaimer',
          component: LegalDisclaimer
        },

        {
          path: 'cx',
          name: 'CX', // TODO: 360Reporting -> CXReporting
          meta: { MessageKey: 'CX', checkPermission: ['360Reporting'] },
          component: CX
        },
        {
          path: 'cx/importmarginfile',
          name: 'CXImportFile',
          meta: { checkPermission: ['360Reporting', 'Import'] },
          component: CXMarginFileImport
        },
        {
          path: 'marketreports',
          name: 'MarketReports',
          meta: { MessageKey: 'MarketReports', checkPermission: ['Market Reports', 'Market Reports Admin'] }, 
          component: MarketReports
        },
        // {
        //   path: 'map',
        //   component: MapView,
        //   beforeEnter: (to, from, next) => {
        //     if (APP_TARGET !== 'bmw') {
        //       next({ path: '/'})
        //     }
        //     else {
        //       next();
        //     }
        //   }
        // },
        {
          path: 'cockpit',
          name: 'Cockpit',
          meta: {
            MessageKey: 'Webportal.Dashboard',
            checkPermission: APP_TARGET === 'porschesar' ? ['CustomDashboard'] : null
          },
          component: Cockpit
        },
        {
          path: 'comparison',
          name: 'Comparison',
          meta: { MessageKey: 'Webportal.DashboardBMW.FocusKPI' },
          component: Comparison
        },

        {
          path: 'reportfileexplorer',
          name: 'ReportFileExplorer',
          meta: { MessageKey: 'Webportal.ReportFileExplorer' },
          component: ReportFileExplorer
        },
        {
          path: 'reportfileimport',
          name: 'ReportFileImport',
          meta: { MessageKey: 'Webportal.ReportFileImport' },
          component: ReportFileImport
        },

        {
          path: 'survey',
          name: 'Survey',
          meta: { MessageKey: 'Webportal.Survey' },
          redirect: '/survey/checkexplorer'
        },
        {
          path: 'survey/checkexplorer',
          name: 'CheckExplorer',
          meta: { MessageKey: 'Webportal.CheckExplorer', checkPermission: ['CheckExplorer'] },
          component: CheckExplorer
        },
        {
          path: 'survey/mediaexplorer',
          name: 'Media explorer',
          meta: { MessageKey: 'Webportal.MediaExplorer', checkPermission: ['MediaExplorer'] },
          component: MediaExplorer
        },
        {
          path: 'survey/rawdata',
          name: 'Raw data',
          meta: { MessageKey: 'Webportal.RawData', checkPermission: ['RawData'] },
          component: RawData
        },
        {
          path: 'survey/frequencies',
          name: 'Frequencies',
          meta: { MessageKey: 'Webportal.Frequencies', checkPermission: ['Frequencies'] },
          component: Frequencies
        },
        {
          path: 'survey/aggregatedreports',
          name: 'Aggregated Reports',
          meta: { MessageKey: 'Webportal.AggregatedReports', checkPermission: ['AggregatedReports'] },
          component: AggregatedReports
        },

        {
          path: 'action',
          name: 'ActionManagement',
          redirect: '/action/surveyrevisionexplorer'
        },
        {
          path: 'action/surveyrevisionexplorer',
          name: 'SurveyRevisionExplorer',
          component: CheckExplorer,
          props: { mode: 'revision' }
        },
        {
          path: 'action/surveyrevision/:id?',
          name: 'SurveyRevision',
          component: SurveyRevision,
          props: route => ({ surveyInstanceId: route.query.sid })
        },
        {
          path: 'action/surveyimprovementexplorer',
          name: 'SurveyImprovementExplorer',
          component: CheckExplorer,
          props: { mode: 'improvement' }
        },
        {
          path: 'action/surveyimprovement/:id?',
          name: 'SurveyImprovement',
          component: SurveyImprovement,
          props: route => ({ surveyInstanceId: route.query.sid })
        },

        {
          path: 'administration',
          name: 'Administration',
          meta: { MessageKey: 'Webportal.Administration' },
          redirect: '/administration/clientsettings',
          component: Administration,
          beforeEnter: (to, from, next) => {
            if (!AuthenticationService.isMSMUser) {
              next(from.path !== to.path ? from.path : '/')
            }
            else {
              next();
            }
          },
          children: [
            {
              path: 'clientsettings',
              name: 'Client settings',
              component: ClientSettings
            },
            {
              path: 'surveysettings',
              name: 'Survey settings',
              component: SurveySettings
            },
            {
              path: 'generalsettings',
              name: 'General settings',
              component: GeneralSettings
            },
            {
              path: 'cxsettings',
              name: 'CX settings',
              component: CXSettings
            },
            {
              path: 'cxclientsettings',
              name: 'CX client settings',
              component: CXClientSettings
            },
            {
              path: 'cxfirstaidsettings',
              name: 'CX first aid settings',
              component: CXFirstAidSettings
            },
            {
              path: 'marketreports',
              name: 'Market reports',
              component: AdministrationMarketReports
            },
          ]
        },
        {
          path: 'administrationnomsmuser',
          name: 'AdministrationNoMSMUser',
          meta: { MessageKey: 'Webportal.Administration' },       
          redirect: (to) => {
            const permissions = AuthenticationService?.localUserProfile?.Permissions || [];
            
            switch (true) {
              case permissions.includes('360Reporting'):
                return '/administrationnomsmuser/cxcompetitorsettings';  
              case permissions.includes('Market Reports Admin'):
                return '/administrationnomsmuser/marketreports';                          
              default:
                return '/administrationnomsmuser/cxcompetitorsettings';
            }
          },
          component: AdministrationNoMSMUser,
          children: [
            {
              path: 'cxcompetitorsettings',
              name: 'CX competitor settings',
              component: CXCompetitorSettings,
              meta: { checkPermission: ['360Reporting'] }
            },
            {
              path: 'marketreports',
              name: 'Market reports non-MSM user',
              component: AdministrationMarketReports,
              meta: { checkPermission: ['Market Reports Admin'] },
            }
          ]
        },
        {
          path: 'user',
          name: 'User',
          meta: { MessageKey: 'Webportal.User' },
          redirect: '/user/profile',
          component: UserSettings,
          children: [
            {
              path: 'profile',
              name: 'Profile',
              component: UserProfile
            },
            {
              path: 'notificationsettings',
              name: 'Notification settings',
              component: NotificationSettings,
              meta: { checkPermission: ['NotificationSettings'] },
            },
            {
              path: 'locationnotifications',
              name: 'Location notifications',
              component: LocationNotifications,
              meta: { checkPermission: ['LocationNotification'] },
            }
          ]
        },
        {
          path: 'imprint',
          name: 'Imprint',
          meta: { MessageKey: 'Webportal.Imprint' },
          component: Imprint
        },
        {
          path: 'dataprotection',
          name: 'DataProtection',
          meta: { MessageKey: 'Webportal.DataProtection' },
          component: DataProtection
        },
        {
          path: 'cockpit2020',
          component: Cockpit,
          beforeEnter: (to, from, next) => {
            if (APP_TARGET !== 'bmw') {
              next({ path: '/' })
            }
            else {
              next();
            }
          }
        },
        {
          path: 'tap',
          component: Tap,
          beforeEnter: (to, from, next) => {
            if (!AuthenticationService.isMSMUser) {
              next({ path: '/' })
            }
            else {
              next();
            }
          }
        }
      ]
    },
    {
      path: '/silentrenew',
      name: 'SilentRenew',
      component: SilentRenew
    },
    {
      path: '/callback',
      component: {
        render(c) {
          // Check if already logged in. This was introduced because when pressing F5 after successful login in Firefox,
          // the callback URL was loaded again but resulted in an error "No matching state found in storage".
          AuthenticationService.getUser().then(() => {
            // If not, then continue callback workflow
            if (!AuthenticationService.isAuthenticated)
              return AuthenticationService.callback();
          }).then(() => {
            // App needs to be restarted (instead of $router.replace) to allow custom theme which is only evaluated once on startup
            if (AuthenticationService.redirectUri)
              location.replace(AuthenticationService.redirectUri);
            else
              location.replace('/');
          }).catch((e) => {
            if (e === 'unauthorized') {
              // Logout user after 5 seconds
              if (!AuthenticationService.isExternalIdentityProvider)
                setTimeout(() => { AuthenticationService.logout(); }, 5000);

              this.$router.push({ name: 'unauthorized' });
            }
            else
              this.$router.push({ name: 'signinfailed' });
          });

          return c(Callback);
        }
      },
    },

    // HACK: AutoLogin SSO
    {
      path: '/isg',
      component: {
        render(c) {
          if (AuthenticationService.isAuthenticated) {
            location.replace('/');
          } else {
            let login_hint = this.$route.query.login_hint;
            if (login_hint) {
              AuthenticationService.login({ login_hint: login_hint }).then(() => {
                if (AuthenticationService.isAuthenticated)
                  location.replace('/');
              });
            } else {
              this.$router.push({ name: 'error' });
            }
          }
        }
      },
    },

    {
      path: '/download/:token',
      component: Download
    },

    {
      path: '/external/login',
      name: 'ExternalLogin',
      component: ExternalLogin
    },
    {
      path: '/external',
      name: 'External',
      meta: { requiresExternalAuth: true },
      redirect: '/external/surveyrevisions',
      component: Full,
      beforeEnter: (to, from, next) => {
        // Remove sicc for security reasons
        if (to.query.sicc) {
          delete to.query.sicc;
          next({ path: to.path, query: to.query, replace: true });
        }
        else
          next();
      },
      children: [
        {
          path: 'surveyrevisions',
          name: 'ExternalSurveyRevisions',
          component: ExternalSurveyRevisions
        },
        {
          path: 'surveyrevision/:id?',
          name: 'ExternalSurveyRevision',
          component: SurveyRevision,
          props: route => ({ surveyInstanceId: route.query.sid })
        },
        {
          path: 'surveyimprovements',
          name: 'ExternalSurveyImprovements',
          component: ExternalSurveyImprovements
        },
        {
          path: 'surveyimprovement/:id?',
          name: 'ExternalSurveyImprovement',
          component: SurveyImprovement,
          props: route => ({ surveyInstanceId: route.query.sid })
        },
        {
          path: 'notificationsettings',
          name: 'ExternalNotificationSettings',
          component: ExternalNotificationSettings
        }
      ]
    },

    // ... the default route, when none of the above matches:
    {
      path: '*',
      name: 'notfound',
      component: Page404
    },

    {
      path: '*',
      name: 'error',
      component: Page500
    },

    {
      path: '*',
      name: 'unauthorized',
      component: Page401
    },

    {
      path: '*',
      name: 'signinfailed',
      component: PageSignInFailed
    },

    {
      path: '*',
      name: 'signedout',
      component: ExternalSignedOut
    },
  ]
});

function checkDisclaimer(to, next) {
  let disclaimer = i18n.te('Webportal.Dialog.LegalDisclaimer.Text') ? (i18n.t('Webportal.Dialog.LegalDisclaimer.Text') ?? '').trim() : '';

  if (to.name !== 'LegalDisclaimer' && disclaimer != '' &&
    (localStorage.getItem('HasUserAcceptedLegalDisclaimer') !== true.toString() || APP_TARGET === "cupra" || APP_TARGET === "porschesar") &&
    sessionStorage.getItem('HasUserAcceptedLegalDisclaimer') !== true.toString()) {
    next({ name: 'LegalDisclaimer', params: { redirectTo: to }, replace: true });
  }
  else
    next();
}

// Check for authentication before navigating to target
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!AuthenticationService.isAuthenticated) {
      AuthenticationService.login({ idp_hint: to.query.idp_hint }).then(() => {
        if (AuthenticationService.isAuthenticated)
        {
          if (to.query.idp_hint) {
            delete to.query.idp_hint;
            next({ path: to.path, query: to.query })
          }
          else
            checkDisclaimer(to, next);
        }
      }).catch((e) => {
        if (e === 'unauthorized') {
          // Logout user after 5 seconds
          if (!AuthenticationService.isExternalIdentityProvider)
            setTimeout(() => { AuthenticationService.logout(); }, 5000);

          router.push({ name: 'unauthorized' });
        }
        else {
          router.push({ name: 'signinfailed' });
        }
      });
    }
    else {
      if (to.query.idp_hint) {
        delete to.query.idp_hint;
        next({ path: to.path, query: to.query })
      }
      else
        checkDisclaimer(to, next);
    }
  }
  else if (to.matched.some(record => record.meta.requiresExternalAuth)) {
    if (!AuthenticationService.isAuthenticatedExternal) {
      AuthenticationService.loginExternal(to).then(() => {
        if (AuthenticationService.isAuthenticatedExternal)
          next();
        else
          next({ name: 'ExternalLogin', params: { redirectTo: to }, replace: true });
      }).catch((e) => {
        next({ name: 'ExternalLogin', params: { redirectTo: to }, replace: true });
      });
    }
    else
      next();
  }
  else
    next();
});

// Check for permissions
router.beforeEach((to, from, next) => {
  const violation = to?.meta?.checkPermission?.find((permission) =>
    AuthenticationService?.localUserProfile?.Permissions?.includes(permission) ? false : permission
  );
  
  // Needed to allow & check for multiple permissions, explicitly for Market Reports (Admin)
  // TODO: we should rethink for a better solution
  if (violation === 'Market Reports' ) {
    AuthenticationService?.localUserProfile?.Permissions?.includes('Market Reports Admin') ? next() : next('/');
  }
  else if (violation === 'Market Reports Admin') {
    AuthenticationService?.localUserProfile?.Permissions?.includes('Market Reports') ? next() : next('/');
  }
  
  // TODO: 360Reporting -> CXReporting
  // CX -> Cockpit -> Checkexplorer
  else if (violation === '360Reporting') {
    const path = AppConfig.methods.hasDashboard() ? '/cockpit' : '/survey/checkexplorer';
    next(path);
  }
  else if (violation === 'CustomDashboard') {
    const path = '/survey/checkexplorer';
    next(path);
  }
  else if (violation) next('/');
  else next();
});

export default router;
